import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Heading from 'components/Heading';
import { SPACE, FONT_SIZES, COLOR } from 'config';
import { rem } from 'polished';
import styled from 'styled-components';
import media from 'utils/media';
import { Flex } from 'grid-styled';
import Button from './Button';

const DividerHeading = styled(Heading)`
  line-height: 2rem;
  text-align:center;
  vertical-align: middle;
  ${media.md.css`
    line-height:2.5rem;
  `}

  b{
    font-weight:normal;
    color:${COLOR.base};
  }
  margin-top: -12px;
  margin-bottom: 2rem;
`;

const Wrapper = styled(Flex)`
  flex-direction:column;
  align-items:center;
  margin-bottom:${rem(SPACE[9])};

  .font-blue:{
    color:${COLOR.base};
  }
`;

const StyledButton = styled(Button)`
  color:${COLOR.white};
  background-color:${COLOR.base};
  border-radius:5px;
  line-height: 1.5 !important;
  font-weight: bold;
  ${media.md.css`
  line-height: 1 !important;
  `};
  &:hover{
    background-color:${COLOR.base};
  }
`;

class WatchAndLearn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile: false,
    };
  }

  componentDidMount() {
    window.onresize = () => {
      if (window.innerWidth < 830) {
        this.setState({ isMobile: true });
      } else {
        this.setState({ isMobile: false });
      }
    };
  }

  componentWillUnmount() {
    window.onresize = () => {};
  }

  render() {
    return (
      <Wrapper px={rem(SPACE[3])}>
        <DividerHeading
          as="h2"
          heavy
          fontSize={[rem(FONT_SIZES[6]), rem(FONT_SIZES[7]), rem(FONT_SIZES[7])]}
          width={['80%', '90%', '90%']}
        >
          { !this.state.isMobile ?
            <FormattedHTMLMessage id="landing.mobileWallets.watchandlearn.text" /> :
            <FormattedHTMLMessage id="landing.mobileWallets.watchandlearn.textMobile" />
          }
        </DividerHeading>
        <StyledButton to="https://www.youtube.com/watch?v=U2zpm-Q8cdc" big width="auto" lineHeight={1.5} px="2.5rem">
          <FormattedMessage id="landing.mobileWallets.watchandlearn.button" />
        </StyledButton>
      </Wrapper>
    );
  }
}

export default WatchAndLearn;



// WEBPACK FOOTER //
// ./src/components/MobileWalletsLanding/components/WatchAndLearn.js